import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'

import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import footerbg from '../Assets/Image/agribannerimage10.png'
import { FaEnvelope, FaPhoneAlt, FaFacebookF, FaLinkedinIn, FaYoutube ,FaInstagram,FaMapMarkerAlt} from 'react-icons/fa'
import { FaTwitter, FaXTwitter } from 'react-icons/fa6';

export default function WebFooter() {
  return (
    <>
   

      <Col lg={12}>
  <div className="footer-brightness-wrapper">
    <div
      className="footer-bg-dim"
      style={{
        backgroundImage: `url(${footerbg})`,
      }}
    ></div>

    <Container className="footer-content">
      <Row className="mt-5">
        <Col lg={5}>
          <h4 className="text-white fw-bold">Hiranand Agri Solutions Pvt. Ltd.</h4>
          <p className="text-white">
Hiranand Agri Solutions Pvt. Ltd. blends scientific, traditional, and modern technologies to empower farmers across India. With a strong focus on increasing productivity, improving incomes, and promoting sustainable agriculture, we are dedicated to delivering accessible, research-driven solutions through training, franchise networks, and digital innovations.
          </p>
        </Col>

        <Col lg={3}>
          <h4 className="text-light fw-bold">Quick Links</h4>
          <ul className="list-unstyled text-white">
            <li><MdKeyboardDoubleArrowRight /><a href="/" className="quick-links">Home</a></li>
            <li><MdKeyboardDoubleArrowRight /><a href="/aboutus" className="quick-links">About Us</a></li>
            <li><MdKeyboardDoubleArrowRight /><a href="/services" className="quick-links">Services</a></li>
              <li><MdKeyboardDoubleArrowRight /><a href="/facilities/Agri" className="quick-links">Facilities</a></li>
            <li><MdKeyboardDoubleArrowRight /><a href="/products" className="quick-links">Products</a></li>
            <li><MdKeyboardDoubleArrowRight /><a href="/gallery" className="quick-links">Gallery</a></li>
            <li><MdKeyboardDoubleArrowRight /><a href="/contact" className="quick-links">Contact</a></li>
          </ul>
        </Col>

        

        <Col lg={4}>
  <h4 className="text-light fw-bold">Connect With Us</h4>

  <p className="text-white mb-2">
    <FaEnvelope className="me-2" />
    contact@hiranandagrisolutions.com
  </p>

  <p className="text-white mb-3">
    <FaPhoneAlt className="me-2" />
   91- 7772036678
     
  </p>
  <p className="text-white mb-3">
    <FaMapMarkerAlt className="me-2" />
  83   sudarshan nagar ab road sarangpur 
Distt Rajgarh Madhya Pradesh Pin code 465697
  </p>
  

  {/* Social Icons Row with Circle Style */}
  <div className="d-flex gap-3 mt-3">
    <a href="https://www.facebook.com/share/p/16aRiH9xhh/" target="_blank" rel="noopener noreferrer" className="social-icon">
      <FaFacebookF />
    </a>
    <a href="https://x.com/samratseeds1234/status/1567840378640023553?t=M04nGOdCkloRLDDYMTUztQ&s=19" target="_blank" rel="noopener noreferrer" className="social-icon">
      < FaXTwitter />
    </a>
   
    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
      <FaLinkedinIn />
    </a>
    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon">
      <FaYoutube />
    </a>
  </div>
</Col>
      </Row>

      <div className="text-white mt-3 footerend text-center">
        <hr />
        <p className='text-white'>© {new Date().getFullYear()} <strong>Hiranand Agri Solutions Pvt. Ltd.</strong> |
          <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a>
        </p>
      </div>
    </Container>
  </div>
</Col>

    </>
  )
}
